export default __webpack_public_path__ + "static/media/SuisseIntl-Bold.82cc5ae2.otf";